import axios from 'axios';
import { BE_BASE_URL, goToLogin } from '../constants/ApiConstants';
import { message } from 'antd';

const API = axios.create({
  baseURL: BE_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      message.error(
        'Your token expired we will try to refresh your screen.if we are unable to please login again. thanks..',
      );
      goToLogin();
    }
  },
);

export default API;
